import { gql } from 'apollo-angular'

export const GET_EDITIONS_BY_MAGAZINE_ID = gql`
  query getEditionsByMagazineId(
    $filter: Edition_where!
    $page: Int
    $limit: Int
    $sort: String
  ) {
    Editions(
      select: true
      where: $filter
      page: $page
      limit: $limit
      sort: $sort
    ) {
      docs {
        id
        edition_version
        title
        volume
        year
        slug
        createdAt
        updatedAt
        published_at
        pdf
      }
      page
      totalDocs
      totalPages
    }
  }
`
